import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  toString1n9qg6fb0b5i8 as toString,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  Char__rangeTo_impl_tkncvpnglpnjmwahwh as Char__rangeTo_impl_tkncvp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_instance2wec3srl1ini as Companion_instance } from './AsciiBitSet.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ILLEGAL_HEADER_NAME_CHARS() {
  _init_properties_HttpHeaders_kt__8vtb1o();
  return ILLEGAL_HEADER_NAME_CHARS;
}
var ILLEGAL_HEADER_NAME_CHARS;
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.i50_1 = 'Accept';
        this.j50_1 = 'Accept-Charset';
        this.k50_1 = 'Accept-Encoding';
        this.l50_1 = 'Accept-Language';
        this.m50_1 = 'Accept-Ranges';
        this.n50_1 = 'Age';
        this.o50_1 = 'Allow';
        this.p50_1 = 'ALPN';
        this.q50_1 = 'Authentication-Info';
        this.r50_1 = 'Authorization';
        this.s50_1 = 'Cache-Control';
        this.t50_1 = 'Connection';
        this.u50_1 = 'Content-Disposition';
        this.v50_1 = 'Content-Encoding';
        this.w50_1 = 'Content-Language';
        this.x50_1 = 'Content-Length';
        this.y50_1 = 'Content-Location';
        this.z50_1 = 'Content-Range';
        this.a51_1 = 'Content-Type';
        this.b51_1 = 'Cookie';
        this.c51_1 = 'DASL';
        this.d51_1 = 'Date';
        this.e51_1 = 'DAV';
        this.f51_1 = 'Depth';
        this.g51_1 = 'Destination';
        this.h51_1 = 'ETag';
        this.i51_1 = 'Expect';
        this.j51_1 = 'Expires';
        this.k51_1 = 'From';
        this.l51_1 = 'Forwarded';
        this.m51_1 = 'Host';
        this.n51_1 = 'HTTP2-Settings';
        this.o51_1 = 'If';
        this.p51_1 = 'If-Match';
        this.q51_1 = 'If-Modified-Since';
        this.r51_1 = 'If-None-Match';
        this.s51_1 = 'If-Range';
        this.t51_1 = 'If-Schedule-Tag-Match';
        this.u51_1 = 'If-Unmodified-Since';
        this.v51_1 = 'Last-Modified';
        this.w51_1 = 'Location';
        this.x51_1 = 'Lock-Token';
        this.y51_1 = 'Link';
        this.z51_1 = 'Max-Forwards';
        this.a52_1 = 'MIME-Version';
        this.b52_1 = 'Ordering-Type';
        this.c52_1 = 'Origin';
        this.d52_1 = 'Overwrite';
        this.e52_1 = 'Position';
        this.f52_1 = 'Pragma';
        this.g52_1 = 'Prefer';
        this.h52_1 = 'Preference-Applied';
        this.i52_1 = 'Proxy-Authenticate';
        this.j52_1 = 'Proxy-Authentication-Info';
        this.k52_1 = 'Proxy-Authorization';
        this.l52_1 = 'Public-Key-Pins';
        this.m52_1 = 'Public-Key-Pins-Report-Only';
        this.n52_1 = 'Range';
        this.o52_1 = 'Referer';
        this.p52_1 = 'Retry-After';
        this.q52_1 = 'Schedule-Reply';
        this.r52_1 = 'Schedule-Tag';
        this.s52_1 = 'Sec-WebSocket-Accept';
        this.t52_1 = 'Sec-WebSocket-Extensions';
        this.u52_1 = 'Sec-WebSocket-Key';
        this.v52_1 = 'Sec-WebSocket-Protocol';
        this.w52_1 = 'Sec-WebSocket-Version';
        this.x52_1 = 'Server';
        this.y52_1 = 'Set-Cookie';
        this.z52_1 = 'SLUG';
        this.a53_1 = 'Strict-Transport-Security';
        this.b53_1 = 'TE';
        this.c53_1 = 'Timeout';
        this.d53_1 = 'Trailer';
        this.e53_1 = 'Transfer-Encoding';
        this.f53_1 = 'Upgrade';
        this.g53_1 = 'User-Agent';
        this.h53_1 = 'Vary';
        this.i53_1 = 'Via';
        this.j53_1 = 'Warning';
        this.k53_1 = 'WWW-Authenticate';
        this.l53_1 = 'Access-Control-Allow-Origin';
        this.m53_1 = 'Access-Control-Allow-Methods';
        this.n53_1 = 'Access-Control-Allow-Credentials';
        this.o53_1 = 'Access-Control-Allow-Headers';
        this.p53_1 = 'Access-Control-Request-Method';
        this.q53_1 = 'Access-Control-Request-Headers';
        this.r53_1 = 'Access-Control-Expose-Headers';
        this.s53_1 = 'Access-Control-Max-Age';
        this.t53_1 = 'X-Http-Method-Override';
        this.u53_1 = 'X-Forwarded-Host';
        this.v53_1 = 'X-Forwarded-Server';
        this.w53_1 = 'X-Forwarded-Proto';
        this.x53_1 = 'X-Forwarded-For';
        this.y53_1 = 'X-Forwarded-Port';
        this.z53_1 = 'X-Request-ID';
        this.a54_1 = 'X-Correlation-ID';
        this.b54_1 = 'X-Total-Count';
        this.c54_1 = 'Last-Event-ID';
        this.d54_1 = 'TDM-Reservation';
        this.e54_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.f54_1 = ['Transfer-Encoding', 'Upgrade'];
        this.g54_1 = asList(this.f54_1);
      }
      h54(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (get_ILLEGAL_HEADER_NAME_CHARS().xp(item)) {
            throw IllegalHeaderNameException().r54(name, _unary__edvuaz);
          }
        }
      }
      i54(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().y54(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(header) {
        return new.target.d55(header);
      }
      static d55(header) {
        var $this = this.o2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.c55_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerName, position) {
        return new.target.r54(headerName, position);
      }
      static r54(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.o2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.q54_1);
        $this.o54_1 = headerName;
        $this.p54_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerValue, position) {
        return new.target.y54(headerValue, position);
      }
      static y54(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.o2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.x54_1);
        $this.v54_1 = headerValue;
        $this.w54_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
var properties_initialized_HttpHeaders_kt_3d6wem;
function _init_properties_HttpHeaders_kt__8vtb1o() {
  if (!properties_initialized_HttpHeaders_kt_3d6wem) {
    properties_initialized_HttpHeaders_kt_3d6wem = true;
    ILLEGAL_HEADER_NAME_CHARS = Companion_instance.j4x(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(0), _Char___init__impl__6a9atx(32))).l4x(Companion_instance.k3o('"(),/:;<=>?@[\\]{}'));
  }
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance1avhj7ffsen7f,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
